document.addEventListener('DOMContentLoaded', function () {
  var mobileDrawer = document.getElementById('MobileDrawer');
  var cartDrawer = document.getElementById('CartDrawer');
  var cartIcon = document.getElementById('CartIconBubble');
  var cartClose = document.getElementById('CartDrawerClose');
  var cartOverlay = document.getElementById('CartDrawerOverlay');

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (mobileDrawer) mobileDrawer.classList.remove('is-open');
      closeCartDrawer();
    }
  });

  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
      refreshCartDrawer();
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  // ---- Cart drawer ----

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function resizeCartImage(url, size) {
    if (!url) return '';
    return url.replace(/(\.[a-zA-Z]{2,4})(\?.*)?$/, '_' + size + 'x' + size + '$1$2');
  }

  function formatMoney(cents) {
    var format = window.themeMoneyFormat || 'Rs. {{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimalsToken = '{' + '{amount_no_decimals}' + '}';
    var formattedAmount = (format.indexOf(noDecimalsToken) !== -1) ? parts[0] : parts.join('.');
    return format.replace(/\{\{\s*(amount_no_decimals|amount)\s*\}\}/, formattedAmount);
  }

  function updateCartCount(count) {
    var el = document.getElementById('CartCount');
    if (el) el.textContent = count;
  }

  function renderCartDrawer(cart) {
    var body = document.getElementById('CartDrawerBody');
    var footer = document.getElementById('CartDrawerFooter');
    if (!body || !footer) return;

    if (!cart || cart.item_count === 0) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      footer.innerHTML = '';
      return;
    }

    var html = '';
    cart.items.forEach(function (item, i) {
      var line = i + 1;
      var hasVariant = item.variant_title && item.variant_title !== 'Default Title';
      html += '<div class="cart-drawer__item" data-line="' + line + '">' +
        '<a href="' + item.url + '" class="cart-drawer__item-image"><img src="' + resizeCartImage(item.image, 160) + '" alt="' + escapeHtml(item.product_title) + '"></a>' +
        '<div class="cart-drawer__item-info">' +
        '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
        (hasVariant ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
        '<div class="cart-drawer__item-row">' +
        '<div class="cart-drawer__qty">' +
        '<button type="button" class="js-qty-minus" data-line="' + line + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" class="js-qty-plus" data-line="' + line + '" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove js-cart-remove" data-line="' + line + '">Remove</button>' +
        '</div>' +
        '</div>';
    });
    body.innerHTML = html;

    footer.innerHTML =
      '<div class="cart-drawer__subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
      // Form + button[name="checkout"] (not a plain link) so the COD King
      // partial-payment popup can intercept checkout from the drawer on any page.
      '<form action="/cart" method="post" style="margin:0"><button type="submit" name="checkout" class="btn btn--dark">Checkout</button></form>' +
      (window.themeCartOfferBanner
        ? '<div class="cart-drawer__offer"><img src="' + window.themeCartOfferBanner + '" alt="Damage-free delivery. Ships in 7 days. COD available up to Rs. 5,000 — above Rs. 5,000 pay just 10%." loading="lazy"></div>'
        : '');
  }

  function refreshCartDrawer() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(function () {});
  }

  // Routes "Buy It Now" (and any other direct-to-checkout action) through the
  // COD King payment popup, so the customer can pick full or partial payment.
  // COD King only hooks button[name="checkout"], so we reuse the cart drawer's
  // checkout button once COD King has attached its listener to it.
  window.themeOpenPaymentPopup = function (done) {
    var finish = function (ok) { if (typeof done === 'function') done(ok); };
    refreshCartDrawer()
      .then(function () {
        var tries = 0;
        (function waitForCodKing() {
          var btn = document.querySelector('#CartDrawerFooter button[name="checkout"]');
          var hooked = btn && btn.getAttribute('codk-data-event-listener') === 'true';
          if (hooked) { btn.click(); finish(true); return; }
          if (++tries > 40) {
            if (btn) { btn.click(); finish(true); }
            else { window.location.href = '/checkout'; }
            return;
          }
          setTimeout(waitForCodKing, 100);
        })();
      })
      .catch(function () { window.location.href = '/checkout'; });
  };

  // --- Cart page: instant quantity updates (no "Update Cart" click needed) ---
  var cartTable = document.querySelector('.cart-table');
  if (cartTable) {
    var cartQtyTimer = null;

    var syncCartPage = function () {
      var inputs = Array.prototype.slice.call(cartTable.querySelectorAll('input[name="updates[]"]'));
      if (!inputs.length) return;
      var updates = inputs.map(function (el) {
        var q = parseInt(el.value, 10);
        return isNaN(q) || q < 0 ? 0 : q;
      });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // A removed line (qty 0) changes row indexes; re-render server-side.
          if (updates.indexOf(0) !== -1 || cart.item_count === 0) { location.reload(); return; }
          var rows = cartTable.querySelectorAll('tbody tr');
          cart.items.forEach(function (item, i) {
            var row = rows[i];
            if (!row) return;
            row.children[2].textContent = formatMoney(item.final_price);
            row.children[4].textContent = formatMoney(item.final_line_price);
            var input = row.querySelector('input[name="updates[]"]');
            if (input && document.activeElement !== input) input.value = item.quantity;
          });
          var subtotal = document.getElementById('CartSubtotal');
          if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
          updateCartCount(cart.item_count);
          renderCartDrawer(cart);
        })
        .catch(function () {});
    };

    var queueCartSync = function (delay) {
      clearTimeout(cartQtyTimer);
      cartQtyTimer = setTimeout(syncCartPage, delay);
    };

    cartTable.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[name="updates[]"]')) queueCartSync(250);
    });
    cartTable.addEventListener('input', function (e) {
      if (e.target && e.target.matches('input[name="updates[]"]')) queueCartSync(600);
    });
  }

  function changeCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var minus = target.closest('.js-qty-minus');
    var plus = target.closest('.js-qty-plus');
    var remove = target.closest('.js-cart-remove');
    var trigger = minus || plus || remove;
    if (!trigger) return;

    var line = parseInt(trigger.getAttribute('data-line'), 10);
    var itemEl = trigger.closest('.cart-drawer__item');
    var qtySpan = itemEl ? itemEl.querySelector('.cart-drawer__qty span') : null;
    var currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 0;

    var newQty;
    if (remove) newQty = 0;
    else if (plus) newQty = currentQty + 1;
    else newQty = Math.max(0, currentQty - 1);

    changeCartLine(line, newQty);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card__variant-btn');
    if (!btn || btn.disabled) return;

    var card = btn.closest('.product-card');
    if (!card) return;

    card.querySelectorAll('.product-card__variant-btn').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');

    var idInput = card.querySelector('.product-card__form input[name="id"]');
    if (idInput) idInput.value = btn.getAttribute('data-variant-id');

    var priceEl = card.querySelector('[data-product-card-price]');
    if (priceEl) {
      if (btn.getAttribute('data-on-sale') === 'true') {
        priceEl.innerHTML = '<span class="compare">' + btn.getAttribute('data-compare-at-price') + '</span><span class="sale">' + btn.getAttribute('data-price') + '</span>';
      } else {
        priceEl.textContent = btn.getAttribute('data-price');
      }
    }

    var addBtn = card.querySelector('.product-card__add');
    if (addBtn) {
      var available = btn.getAttribute('data-available') === 'true';
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      addBtn.classList.toggle('js-add-to-cart', available);
      addBtn.classList.toggle('btn--outline', !available);
      addBtn.type = available ? 'submit' : 'button';
    }
  });

  document.addEventListener('submit', function (e) {
    var submitter = e.submitter;
    if (!submitter && document.activeElement && document.activeElement.classList && document.activeElement.classList.contains('js-add-to-cart')) {
      submitter = document.activeElement;
    }
    if (!submitter || !submitter.classList || !submitter.classList.contains('js-add-to-cart')) return;

    e.preventDefault();
    var form = e.target;
    var originalText = submitter.textContent;
    submitter.disabled = true;
    submitter.textContent = 'Adding...';

    // If this form has a checked optional add-on checkbox (see main-product.liquid),
    // bundle both the main item and the add-on into a single cart/add.js call.
    var addonInput = form.querySelector('.js-addon-checkbox');
    var addToCartRequest;
    if (addonInput && addonInput.checked && addonInput.getAttribute('data-addon-variant-id')) {
      var mainIdInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var mainId = mainIdInput ? mainIdInput.value : null;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var addonId = addonInput.getAttribute('data-addon-variant-id');
      addToCartRequest = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [ { id: mainId, quantity: qty }, { id: addonId, quantity: 1 } ] })
      });
    } else {
      var formData = new FormData(form);
      addToCartRequest = fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });
    }

    addToCartRequest
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          alert(data.description || 'Could not add item to cart.');
          return;
        }
        return refreshCartDrawer().then(function () { openCartDrawer(); });
      })
      .catch(function () {
        alert('Something went wrong adding this item to your cart.');
      })
      .finally(function () {
        submitter.disabled = false;
        submitter.textContent = originalText;
      });
  });
});
;(function(){function debounce(fn,wait){var t;return function(){var args=arguments;clearTimeout(t);t=setTimeout(function(){fn.apply(null,args)},wait)}}function escapeHtml(str){return String(str==null?"":str).replace(/[&<>"']/g,function(c){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]})}function formatPrice(amount){var num=parseFloat(amount||0);return "₹"+num.toLocaleString("en-IN",{minimumFractionDigits:2,maximumFractionDigits:2})}function resizeImage(url,size){return url?url.replace(/(\.[a-zA-Z]{2,4})(\?.*)?$/,"_"+size+"x"+size+"$1$2"):""}function renderPredictiveResults(container,products){if(!products||!products.length){container.innerHTML='<div class="predictive-search__empty">No products found.</div>';return}container.innerHTML=products.map(function(p){return '<a href="'+p.url+'" class="predictive-search__item"><img class="predictive-search__image" src="'+resizeImage(p.image,100)+'" alt="'+escapeHtml(p.title)+'" loading="lazy"><span class="predictive-search__info"><span class="predictive-search__title">'+escapeHtml(p.title)+'</span><span class="predictive-search__price">'+formatPrice(p.price)+'</span></span></a>'}).join("")}document.addEventListener("DOMContentLoaded",function(){var input=document.getElementById("HeaderSearchInput"),results=document.getElementById("PredictiveSearchResults");if(!input||!results)return;var fetchResults=debounce(function(query){if(!query){results.hidden=true;results.innerHTML="";return}fetch("/search/suggest.json?q="+encodeURIComponent(query)+"&resources[type]=product&resources[limit]=6").then(function(r){return r.json()}).then(function(data){var products=(data.resources&&data.resources.results&&data.resources.results.products)||[];renderPredictiveResults(results,products);results.hidden=false}).catch(function(){results.hidden=true})},250);input.addEventListener("input",function(){fetchResults(input.value.trim())});input.addEventListener("focus",function(){if(input.value.trim()&&results.innerHTML)results.hidden=false});document.addEventListener("click",function(e){if(!results.contains(e.target)&&e.target!==input)results.hidden=true});input.addEventListener("keydown",function(e){if(e.key==="Escape")results.hidden=true})})})();
;(function(){function closeAll(){document.querySelectorAll('.collection-filter-dropdown.is-open').forEach(function(d){d.classList.remove('is-open')})}document.addEventListener('click',function(e){var trigger=e.target.closest('[data-collection-filter-trigger]');if(trigger){var dropdown=trigger.closest('[data-collection-filter]');var wasOpen=dropdown.classList.contains('is-open');closeAll();if(!wasOpen){dropdown.classList.add('is-open')}return}if(!e.target.closest('[data-collection-filter]')){closeAll()}});document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeAll()}})})();

document.addEventListener('DOMContentLoaded', function () {
  function getRowCount(container) {
    var tops = [];
    container.querySelectorAll('.product-card__variant-btn').forEach(function (b) {
      if (tops.indexOf(b.offsetTop) === -1) tops.push(b.offsetTop);
    });
    return tops.length;
  }

  function updateVariantDisplay(card) {
    var row = card.querySelector('.product-card__variants');
    var select = card.querySelector('.product-card__variant-select');
    if (!row || !select) return;
    row.style.display = 'flex';
    select.style.display = 'none';
    if (getRowCount(row) > 2) {
      row.style.display = 'none';
      select.style.display = 'block';
    }
  }

  function updateAllVariantDisplays() {
    document.querySelectorAll('.product-card').forEach(updateVariantDisplay);
  }

  updateAllVariantDisplays();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateAllVariantDisplays, 200);
  });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('.product-card__variant-select');
    if (!select) return;
    var card = select.closest('.product-card');
    if (!card) return;
    var option = select.options[select.selectedIndex];
    if (!option || option.disabled) return;

    card.querySelectorAll('.product-card__variant-btn').forEach(function (b) {
      b.classList.toggle('is-selected', b.getAttribute('data-variant-id') === option.getAttribute('data-variant-id'));
    });

    var idInput = card.querySelector('.product-card__form input[name="id"]');
    if (idInput) idInput.value = option.getAttribute('data-variant-id');

    var priceEl = card.querySelector('[data-product-card-price]');
    if (priceEl) {
      if (option.getAttribute('data-on-sale') === 'true') {
        priceEl.innerHTML = '<span class="compare">' + option.getAttribute('data-compare-at-price') + '</span><span class="sale">' + option.getAttribute('data-price') + '</span>';
      } else {
        priceEl.textContent = option.getAttribute('data-price');
      }
    }

    var addBtn = card.querySelector('.product-card__add');
    if (addBtn) {
      var available = option.getAttribute('data-available') === 'true';
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      addBtn.classList.toggle('js-add-to-cart', available);
      addBtn.classList.toggle('btn--outline', !available);
      addBtn.type = available ? 'submit' : 'button';
    }
  });
});